var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"sm":"12","md":"6","lg":"3","cols":"12"}},[_c('v-card',{attrs:{"min-height":"150px"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }